// Simple event emitter for profile pic expiration
// Used to communicate between ContactAvatar (detects expired URLs) and useWaContactsLazyLoad (handles re-fetch)

type ExpiredCallback = (contactId: string) => void;

class ProfilePicExpiredEmitter {
    private listeners: Set<ExpiredCallback> = new Set();

    // Called by ContactAvatar when an image fails to load
    markExpired(contactId: string) {
        this.listeners.forEach(callback => callback(contactId));
    }

    // Called by useWaContactsLazyLoad to register for expiration events
    subscribe(callback: ExpiredCallback): () => void {
        this.listeners.add(callback);
        return () => {
            this.listeners.delete(callback);
        };
    }
}

// Singleton instance
export const profilePicExpiredEmitter = new ProfilePicExpiredEmitter();
